import { ChargeTypes } from '@enums/charge-types';
import { CreditCardPayment } from '@medology/ngx-payment';
import { AbstractSubscriptionBillingUpdateRequest } from '@models/requests/abstract-subscription-billing-update-request.model';

/**
 * Payload to update a subscription's billing info with a credit card.
 */
export class SubscriptionBillingCreditCardUpdateRequest extends AbstractSubscriptionBillingUpdateRequest {
  public card_number: string;
  public card_expiration: string;
  public cvv: string;
  public billing_country: string;
  public billing_zip_code: string;

  public constructor(payment: CreditCardPayment) {
    super(ChargeTypes['Credit Card']);
    this.card_number = payment.cardNumber;
    this.card_expiration = this.formatExpiration(payment);
    this.cvv = payment.cardCvv;
    this.billing_country = payment.billingCountry;
    this.billing_zip_code = payment.billingZipCode;
  }

  /**
   * Formats the card expiration the way the API expects it: a four digit MMYY string.
   *
   * @param {CreditCardPayment} payment the credit card payment to read the expiration from
   *
   * @returns {string} the expiration as MMYY
   */
  private formatExpiration(payment: CreditCardPayment): string {
    const month = `${payment.expirationMonth}`.padStart(2, '0');

    return `${month}${`${payment.expirationYear}`.slice(-2)}`;
  }
}
